import init from '../../helpers/init';

const {$, _} = init;
const BX = (<any>window).BX;

$(() => {
  $(document).on('click', '.js-barcode-report', function(event) {
    event.preventDefault();

    const data = {
      'exhibitionXml': 'RM21',
      'firm': 0,
    };

    BX.ajax.runComponentAction('pwd:statistic.personal.bar', 'exportExcel', {
      data,
      mode: 'class'
    }).then((result: any) => {
      console.log(result.data);
    }).catch((err: any) => {
      alert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });
  });

});
